const other = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async saveUseApply({ rootState }, params = {}) {
      const data = await rootState.http("/information/entry/save/trialApplication", params);
      return data;
    }
  }
};

export default other;



// WEBPACK FOOTER //
// ./src/store/modules/other.js